// import React from 'react';

// export default function AboutsUs() {
//   return (
//     <section className="py-20 bg-gray-50">
//       <div className="container mx-auto px-4">
//         <div className="flex flex-wrap items-center -mx-4">
//           <div className="w-full lg:w-1/2 px-4 mb-12 lg:mb-0">
//             <div className="relative">
//               <img
//                 src="/images/Env1.jpg"
//                 alt="About"
//                 className="rounded-lg shadow-lg w-full"
//               />
//               <div className="absolute -bottom-8 -right-4 sm:-right-8 bg-white p-4 rounded-lg shadow-lg w-full max-w-xs sm:w-64">
//                 <div className="text-center">
//                   <span className="text-3xl font-bold text-green-600">05</span>
//                   <p className="text-gray-600">Years of Experience</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="w-full lg:w-1/2 px-4">
//             <span className="text-green-600 font-medium mb-2 block">Who we are</span>
//             <h2 className="text-3xl md:text-4xl font-bold mb-6">
//               Customs Consultant & EPR Compliances
//             </h2>
//             <p className="text-gray-600 mb-4">
//               Environature Solution Dedicated To Delivering Tailored, High-Impact Solutions To A
//               Diverse Clientele. With A Commitment To Excellence, Integrity, And Client
//               Satisfaction, We Bring Expertise In Various Industries, Including Waste management,
//               Electronics, IT Telecom, Steel And Iron, Chemical, Fertilizers, Textile, Footwear,
//               Medical Devices, Drugs And Cosmetics.
//             </p>
//             <p className="text-gray-600">
//               Our Client- Centric Approach, Driven By A Team Of Experienced Professionals, Ensures
//               We Listen, Innovate, And Produce Tangible Results That Empower Organizations To Thrive
//               In A Rapidly Changing World. Choose Environature Solution As Your Trusted Consulting
//               Partner And Embark On A Path To Success Through Customized, Results-Oriented Guidance.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }


import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

// Variants
const containerVariant = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

const textParent = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    }
  }
};

const textLine = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const AboutUs = () => {
  return (
    <motion.section
      className="py-20 bg-gray-50"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.2 }}
      variants={containerVariant}
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12">

          {/* Text Content */}
          <motion.div
            className="w-full lg:w-1/2"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={textParent}
          >
            <motion.span
              variants={textLine}
              className="text-green-600 font-medium mb-3 block uppercase tracking-wide"
            >
              Who we are
            </motion.span>

            <motion.h2
              variants={textLine}
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-snug"
            >
              Customs Consultant & EPR Compliances
            </motion.h2>

            <motion.p
              variants={textLine}
              className="text-gray-600 mb-4 leading-relaxed"
            >
              Environature Solution is dedicated to delivering tailored, high-impact solutions to a
              diverse clientele. With a commitment to excellence, integrity, and client satisfaction,
              we bring expertise in various industries including waste management, electronics, IT/telecom,
              steel and iron, chemicals, fertilizers, textiles, footwear, medical devices, and cosmetics.
            </motion.p>

            <motion.p
              variants={textLine}
              className="text-gray-600 leading-relaxed"
            >
              Our client-centric approach, driven by a team of experienced professionals, ensures we listen,
              innovate, and produce tangible results that empower organizations to thrive in a rapidly
              changing world. Choose Environature Solution as your trusted consulting partner and embark
              on a path to success through customized, results-oriented guidance.
            </motion.p>
          </motion.div>

          {/* Image with floating card */}
          <motion.div
            className="w-full lg:w-1/2 relative"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <div className="relative w-full max-w-xl mx-auto">
              <Link to="/about">
              <motion.img
                src="/images/Env1.jpg"
                alt="About"
                className="rounded-lg shadow-xl w-full object-cover"
                whileHover={{ scale: 1.02 }}
                transition={{ type: 'spring', stiffness: 300 }}
              />
              </Link>

              {/* Floating badge with bounce effect */}
              <motion.div
                className="absolute -bottom-8 -right-4 sm:-right-8 bg-gray-50 p-4 rounded-xl shadow-lg w-60 sm:w-64"
                initial={{ y: 40, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ type: 'spring', stiffness: 120, delay: 0.3 }}
                viewport={{ once: false }}
              >
                <div className="text-center">
                  <span className="text-4xl font-bold text-green-600 animate-pulse">05+</span>
                  <p className="text-gray-700 font-medium">Years of Experience</p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutUs;
